import Reveal from "@/components/Reveal";
import { CheckCircle2 } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    title: "The Cleenvo Standard",
    text: "Cleenvo is our own manufacturing brand — floor cleaners, detergents, dishwash gels, hand wash and toilet cleaners formulated to be tough on dirt, safe for everyday use and refreshingly fragrant. Every batch is quality-checked before it leaves our facility.",
  },
  {
    num: "02",
    title: "B2B Excellence",
    text: "We supply offices, housing societies, hotels, hospitals and retailers across the region with wholesale pricing, GST invoicing, dependable stock and on-schedule deliveries — so your operations never pause for want of supplies.",
  },
  {
    num: "03",
    title: "Pan-India Network",
    text: "From our base in Mundhwa, Pune, we fulfil bulk and wholesale orders across India. Cleenvo products are available on officiaa.com, Amazon and Flipkart — with quick-commerce platforms coming soon.",
  },
];

const BENEFITS = ["Wholesale pricing", "GST invoicing", "Bulk & 5L packs", "On-time delivery", "Dedicated support", "Credit terms"];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 lg:gap-24">
        <div className="lg:sticky lg:top-32 self-start">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-greenDark" data-testid="about-overline">About Sevayog</p>
            <h2 className="mt-4 font-display text-4xl md:text-5xl font-black tracking-tight text-slate-900" data-testid="about-heading">
              Our <span className="font-serif italic font-semibold text-brand-blue">Manifesto</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600" data-testid="about-description">
              Sevayog Facilities Pvt Ltd is a wholesale supplier of housekeeping and office essentials.
              We exist to make facility procurement effortless — one dependable partner, honest pricing,
              and products we are proud to put our name on.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 overflow-hidden rounded-[2rem] rounded-bl-[4rem] border border-slate-200">
              <img src="/assets/about-minimal.jpg" alt="Cleenvo minimal cleaning products" className="h-72 w-full object-cover" data-testid="about-image" />
            </div>
            <div className="mt-8 flex flex-wrap gap-2.5" data-testid="about-benefits">
              {BENEFITS.map((b) => (
                <span key={b} className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-3.5 py-1.5 text-xs font-medium text-slate-700">
                  <CheckCircle2 size={13} className="text-brand-green" />
                  {b}
                </span>
              ))}
            </div>
          </Reveal>
        </div>

        <div data-testid="about-chapters">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.1}>
              <div className="relative border-t border-slate-200 py-12 pl-24 md:pl-32 group" data-testid={`about-chapter-${c.num}`}>
                <span className="absolute left-0 top-8 font-serif italic text-6xl md:text-7xl text-slate-200 transition-colors duration-500 group-hover:text-brand-green/40 select-none">
                  {c.num}
                </span>
                <h3 className="font-display text-2xl font-extrabold tracking-tight text-slate-900">{c.title}</h3>
                <p className="mt-4 text-base leading-relaxed text-slate-600">{c.text}</p>
              </div>
            </Reveal>
          ))}
          <div className="border-t border-slate-200" />
        </div>
      </div>
    </section>
  );
}
